import styled from 'styled-components'
import { typoHeading5 } from '../../lib/styles/Typography'

export const Styled = {
  Hint: styled.div`
    background-color: ${({ theme }) => theme.colors.azure[7]};
    padding: 2rem;
    border-radius: 1rem;
    margin-top: 3rem;
    display: flex;
    flex-direction: column;

    &:has(+ .hint-block) {
      margin-bottom: -2rem;
    }

    @media screen and (max-width: 576px) {
      padding: 1.35rem;
    }
  `,

  Headline: styled.h2`
    ${typoHeading5};
  `,

  Content: styled.div`
    & > .is-prose:last-child {
      margin-bottom: 0;
    }
  `,
}
